module.exports = __webpack_public_path__ + "img/ico-pill_arrow.f884e90c.svg";